import { NumberUtils } from '../../javascripts-es6/utilities/number';

Wahanda.Number = NumberUtils;
